import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import HowToBuy from './components/HowToBuy';
import Tokenomics from './components/Tokenomics';
import Roadmap from './components/Roadmap';
import News from './components/News';
import Whitepaper from './components/Whitepaper';
import Footer from './components/Footer';
import AdminPanel from './components/AdminPanel';
import { Toaster } from 'sonner';

function App() {
  return (
    <Router>
      <div className="App">
        <Toaster position="top-center" richColors />
        <Routes>
          {/* Admin Route */}
          <Route path="/admin" element={<AdminPanel />} />
          
          {/* Main Site */}
          <Route
            path="/"
            element={
              <>
                <Header />
                <main>
                  <Hero />
                  <HowToBuy />
                  <Tokenomics />
                  <Roadmap />
                  <News />
                  <Whitepaper />
                </main>
                <Footer />
              </>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
